import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { Form, TextAreaInput } from '../../UI'
import { validateRequired, validateLength } from '../../../libs/validation'

import { translate } from 'react-i18next'
import { NotificationManager } from 'react-notifications'

import UPDATE_PLANNER_PROFILE_QUERY from './../../../graphql/UpdatePlannerProfileAboutMyself.graphql'
import USER_WITH_PLANNER_QUERY from '../../../graphql/UserByID.graphql'
import Loader from '../../UI/Loader'
import get from 'lodash/get'

class DescriptionForm extends Component {
  state = {
    saving: false,
    routeIndex: 1
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true
    })
    
      this.props
        .updatePlannerProfile({
          variables: {
            id: this.props.data.User.plannerProfile.id,
            aboutMyself: values.aboutMyself
          }
        })
        .then(() => {
          this.setState({
            saving: false
          })
          this.props.data.refetch()
          NotificationManager.success('Description updated', 'Success', 5000)
          this.props.history.push('/create-guru-profile/location')
        })
        .catch(err => {
          this.setState({
            saving: false
          })
          NotificationManager.error('Error while updating description', 'Error', 5000)
        })
  }

  render() {
    const { t } = this.props

    if (this.props.data.user[0].loading) {
      return <Loader showLoader={true} />
    }

    const aboutMyself = this.props.data.user.plannerProfile ? this.props.data.user.plannerProfile.aboutMyself : ''

    const { saving } = this.state

    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">Description</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('short_description')}</div>
            <div className="form-input-example">{t('short_description_example')}</div>

            <TextAreaInput
              id="aboutMyself"
              placeholder={t('short_description_placeholder')}
              initialValue={aboutMyself}
              maxChars={600}
              minChars={80}
              validationFuncs={[validateRequired, validateLength]}
              isGroup={false}
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('guru'),
  graphql(UPDATE_PLANNER_PROFILE_QUERY, {
    name: 'updatePlannerProfile'
  }),
  graphql(USER_WITH_PLANNER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user[0].id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  withRouter
)
export default enhance(DescriptionForm)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/DescriptionForm.jsx